/** Sandwich conversion flag: cell and DB are LP; flag stops WO paint/heal. */

export function sandwichAppliedFromRecord(record) {
  if (!record || typeof record !== "object") return false;
  const v = record.sandwichApplied ?? record.sandwich_applied;
  return v === true || v === 1 || v === "1";
}

export function sandwichUnpaidWoCount(detailByDay, attendanceByDay, daysInMonth) {
  let n = 0;
  const last = Number(daysInMonth) || 0;
  if (!detailByDay || last < 1) return 0;
  for (let day = 1; day <= last; day += 1) {
    const d = detailByDay[day] || detailByDay[String(day)];
    if (!sandwichAppliedFromRecord(d)) continue;
    const status = String(
      attendanceByDay?.[day] ??
        attendanceByDay?.[String(day)] ??
        d?.status ??
        ""
    )
      .trim()
      .toUpperCase();
    if (status === "WO") n += 1;
  }
  return n;
}
